<template>
    <div class="webting">
      <div class="list">
        <textarea class="textarea" v-model="content" :placeholder="placeholder"/>
        <div class="btn">
<!--          <van-button color="#FF5700"  @click="close" size="small">{{$t('append_field.cancel')}}</van-button>
          <span style="width: 20px;display: inline-block"></span>-->
          <van-button color="#006EFF" @click="submit" size="small">{{$t('append_field.confirm')}}</van-button>
        </div>
      </div>
    </div>

</template>

<script>
  import {
    mapState,
  } from 'vuex'
  import {Toast} from "vant";
  import _ from "lodash";

  export default {
    props: {
      text: {
        type: Object,
      },
    },
    data(){
      return {
        backup: '',
        content: '',
        placeholder: this.$t('append_field.enterURL'),
      }
    },
    mounted() {
      if(this.text){
        this.content=this.text.txList[0].taContent
      }
      this.backup = _.cloneDeep(this.$store.state.componentsList[this.controlIndex]);
    },
    methods: {
      replace() {
        this.$emit('edit')
      },
      submit() {
        if (this.content === '') {
          Toast(this.$t('append_field.enterText'))
          return
        }else {
          Toast(this.$t('append_field.add_success'))
        }
        this.$emit('setText', this.content)
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
      close() {
        this.$store.state.componentsList[this.controlIndex].txList = this.backup.txList
        this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.backup)
        this.$emit('close')
      },
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      })
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .webting {

    .textarea {
      border: 1px solid #d8d8db;
      background: $uni-text-color-inverse;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 7px;
      width: 100%;
      height: 100px;
      margin-bottom: 20px;
    }
    .btn {
      text-align: right;
      //margin-top: 30px;
    }
    .control-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 50px;

      .control-item-title {
        font-size:  15px;
      }

      .control-item-icon {
      }
    }
    .control-item-animation {
      position: absolute;
      width: 100%;
      bottom: -100px;
      left: 0;
      height: 50px;
      background: $uni-border-bottom-color;
      z-index: 5;
      transition: bottom 1s;
      overflow: auto;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .a {
        background: #ff0000 !important;
        border-radius: 5px;
      }

      .control-item-view {
        height: 25px;
        line-height: 25px;
        min-width: 100px;
        font-size:  15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 2 upx solid $uni-text-color-placeholder;
        color: $uni-text-color-inverse;
      }

      .control-item-view:nth-of-type(1) {
        border-left: none;
      }
    }

  }


  .effect-show {
    bottom: 50px;
  }
</style>
